import React, { useState } from "react";
import PlacesAutocomplete, { geocodeByAddress,getLatLng} from "react-places-autocomplete";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";


export default function SearchPlace(props) {
  const [address, setAddress] = useState("");
  const [list, setList] = useState(false);
  const [spinnerActive, spinnerActiveFun] = useState(false);


  const handleChange = (e) => { setAddress(e); setList(true); props.onFieldTextChange(e, "") };

  const handleSelect = address => {
    spinnerActiveFun(true)
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        props.onLatlanChange(`${latLng.lat},${latLng.lng}`)
        spinnerActiveFun(false)
      })
      .catch(error => console.error('Error', error));
  };

  const handleSelect1 = (v1, v2) => {
    props.onFieldTextChange(v1, v2)
    setAddress(v1);
    setList(false);
  };


  return (<PlacesAutocomplete
            value={address}
            onChange={handleChange}
            onSelect={handleSelect}
          >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesomeIcon type={'regular'} icon={'location-dot'} iconClass={'fs-6'} />
                  </span>
                </div>
                <input {...getInputProps({ placeholder: "Type address" })} className={`form-control ${props.error?'is-invalid':''}`}  autoComplete="off"/>
              </div>
              
              
              {spinnerActive ? <div className="spinner spinner-gray" style={{top:-22}}></div> : null}
              {list && address.length > 0 ?
                <Dropdown className={`w-100`} show>
                  <Dropdown.Menu className="w-100">
                      <PerfectScrollbar options={ { wheelPropagation: false } }>
                        {suggestions.map(suggestion => {
                          return (<Dropdown.Item className="text-break" {...getSuggestionItemProps(suggestion)} onClick={() => { handleSelect1(suggestion.description, suggestion.placeId); handleSelect(suggestion.description) }} style={{whiteSpace:'normal'}}> {suggestion.description}</Dropdown.Item>);
                        })}
                      </PerfectScrollbar>
                  </Dropdown.Menu>
                </Dropdown>
                : ''}
            </div>
        )}
      </PlacesAutocomplete>
  );
}

